import React from 'react'
import {LocationIcon} from '@modifi/ui'

import {Address} from '../../../../types/common'

import {
  SuggestionAddress,
  SuggestionCompanyName,
  SuggestionWrapper,
  AddressText,
  LocationIconWrapper,
} from './styles'

type SuggestionProps = {
  address?: Address | null
  companyName: string
}

const Suggestion: React.FC<SuggestionProps> = ({address, companyName}) => {
  const addressParts = []

  if (address?.streetName) {
    addressParts.push(address.streetName)
  }
  if (address?.streetNumber) {
    addressParts.push(address.streetNumber)
  }
  if (address?.zipCode) {
    addressParts.push(address.zipCode)
  }
  if (address?.city) {
    addressParts.push(address.city)
  }
  return (
    <SuggestionWrapper className="notranslate">
      <SuggestionCompanyName>
        <span>{companyName}</span>
      </SuggestionCompanyName>
      <SuggestionAddress>
        <LocationIconWrapper>
          <LocationIcon height={28} width={16} />
        </LocationIconWrapper>

        <AddressText>{addressParts.join(', ')}</AddressText>
      </SuggestionAddress>
    </SuggestionWrapper>
  )
}

export default Suggestion
